












































































import { Component, Vue } from 'vue-property-decorator';
import { resetPassword } from '../../api/api';
import get from 'lodash/get';
import ButtonLoading from '@/components/ButtonLoading.vue';

@Component({
    components: {
        ButtonLoading,
    },
})
export default class ForgotPassword extends Vue {
    first: string = '';
    second: string = '';
    submit: boolean = false;
    loading: boolean = false;
    token: string | null = null;

    created() {
        this.token = (this.$route.query.token as string) || null;
    }

    get errorFirst(): string | null {
        if (this.first === '') {
            return 'Ce champ ne peux pas être vide';
        }
        if (this.first !== this.second) {
            return `Les mots de passe ne correspondent pas`;
        }
        return null;
    }
    get errorSecond(): string | null {
        if (this.second === '') {
            return 'Ce champ ne peux pas être vide';
        }
        if (this.first !== this.second) {
            return `Les mots de passe ne correspondent pas`;
        }
        return null;
    }

    async onSubmit() {
        this.loading = true;
        const $vs = (this as any).$vs;
        this.submit = true;
        if (!this.token) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Erreur avec le lien`,
            });
            this.loading = false;
            return;
        }
        if (this.first === '' || this.second === '') {
            this.loading = false;
            return;
        }
        if (this.first !== this.second) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Les mots de passe ne correspondent pas`,
            });
            this.loading = false;
            return;
        }
        try {
            const plainPassword = {
                first: this.first,
                second: this.second,
            };
            await resetPassword(this.token, plainPassword);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Récupération de mot de passe',
                text: `Mot de passe modifié.`,
            });
            this.$router.push({ name: 'login' });
        } catch (error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: get(
                    error,
                    'response.data.message',
                    'Erreur lors de la soumission du formulaire'
                ),
            });
        } finally {
            this.loading = false;
        }
    }
}
